import { API, ENDPOINTS } from '@/app/services/api-url';
import RequestAccess from '../request-access/request-access.vue';
import GetStartedItem from './get-started-item/get-started-item.vue';
import RecentActivity from '@/app/modules/home/components/recent-activity/recent-activity.vue';
import ControlCentre from '@/app/modules/home/components/control-centre/control-centre.vue';

const absorbURL = process.env.VUE_APP_ABSORB_URL;

export default {
  name: 'get-started',
  components: {
    ControlCentre,
    RecentActivity,
    GetStartedItem,
    RequestAccess,
  },
  data() {
    return {
      showRequest: false,
      SIDActivationCode: null,
      SIDLoading: false,
    };
  },
  computed: {
    hasAccessToCourses() {
      return this.canAccessCourse('FOUNDATIONS')
        || this.canAccessCourse('CONTRIBUTIONS')
        || this.canAccessCourse('EXT_CONTRIBUTIONS')
        || this.canAccessCourse('EXT_BENEFITS')
        || this.canAccessCourse('EXT_DEATHDISABILITY')
        || this.canAccessCourse('SPEC_DEATHDISABILITY')
        || this.canAccessCourse('EXT_FUNDTAXES')
        || this.canAccessCourse('SPEC_FUNDTAXES')
        || this.canAccessCourse('EXT_INPRACTICE')
        || this.canAccessCourse('SPEC_INPRACTICE')
        || this.canAccessCourse('EXT_INVESTMENTS')
        || this.canAccessCourse('SPEC_INVESTMENTS')
        || this.canAccessCourse('EXT_SUPERSMSF')
        || this.canAccessCourse('SPEC_SUPERSMSF')
        || this.canAccessCourse('SPEC_BENEFITS')
        || this.canAccessCourse('SPEC_CONTRIBUTIONS');
    },
    canAccessCourse() {
      return product => this.$store.getters['account/getAccountCanAccess'][product] || false;
    },
    accountUUID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    isAccountOwner() {
      return this.$store.getters['account/isAccountOwner'];
    },
    hasToolkitSubscription() {
      return this.$store.getters['billing/hasSubscriptionByProduct']('TOOLKIT');
    },
    hasCompanionSubscription() {
      return this.$store.getters['billing/hasSubscriptionByProduct']('COMPANION');
    },
    hasBitesSubscription() {
      return this.$store.getters['billing/hasSubscriptionByProduct']('BITES');
    },
    hasFoundationsPurchase() {
      return this.$store.getters['account/getAccountCanAccess'].FOUNDATIONS;
    },
    hasContributionsPurchase() {
      return this.$store.getters['account/getAccountCanAccess'].CONTRIBUTIONS;
    },
    hasToolkitPermission() {
      return this.$store.getters['account/hasAppPermission']('TOOLKIT');
    },
    hasCompanionPermission() {
      return this.$store.getters['account/hasAppPermission']('COMPANION');
    },
    hasBitesPermission() {
      return this.$store.getters['account/hasAppPermission']('BITES');
    },
    companionLink() {
      const companionApp = this.$store.getters['app/activeApps'].filter(app => app.appName === 'COMPANION')[0];
      if (companionApp) {
        return companionApp.url;
      }
      return null;
    },
  },
  methods: {
    subscribe(type) {
      // eslint-disable-next-line no-unused-vars
      return this.$router.push(`/account/subscribe/${type}`).catch((err) => {});
    },
    handleAccess() {
      return this.$router.push('/account/users').catch(() => {});
    },
    handleCourses() {
      // eslint-disable-next-line no-unused-vars
      return this.$router.push('/account/courses').catch((err) => {});
    },
    dashboard() {
      // eslint-disable-next-line no-unused-vars
      return this.$router.push('/toolkit/investment-strategy/dashboard').catch((err) => {});
    },
    companion() {
      if (this.companionLink) {
        this.$store.dispatch('toggleLoading', true, { root: true });
        // hit the token endpoint to get valid token (from client with 1 day access token settings)
        // then open companion with authorisation header being 'Bearer ' plus the jwt
        API.get(`${ENDPOINTS.GET_OAUTH_TOKEN}?appName=COMPANION&accountID=${this.accountUUID}`)
          .then((thisres) => {
            const token = thisres.data.data.access_token;
            const requestOptions = {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${token}`,
              },
              redirect: 'follow',
              credentials: 'include',
              // mode: 'no-cors',
            };
            // the fetch gets the cookie set so the window.open works
            return fetch(this.companionLink, requestOptions);
          })
          .then((response) => { response.text(); })
          .then(() => {
            window.open(this.companionLink, '_blank', 'noopener noreferrer');
          })
          .finally(() => this.$store.dispatch('toggleLoading', false, { root: true }))
          .catch((error) => { console.log(error); });
      }
    },
    bites() {
      this.$mixpanel.track('bites-init', {
        location: 'Dashboard',
      });
      window.open(absorbURL, '_blank', 'noopener noreferrer');
    },
  },
};
